module.exports = __webpack_public_path__ + "img/banner1_960.66b2084b.png";